import * as XLSX from 'xlsx'

interface ProjectExportData {
  nom: string
  description: string | null
  date_kickoff: string
  stack_technique: string | null
  urls: Array<{ url_type: string; url: string }>
  project_manager_nom: string | null
  project_managers?: Array<{ nom: string | null; email: string | null }>
  activity_sector_nom: string | null
}

function getFigmaUrls(urls: Array<{ url_type: string; url: string }>): string {
  return urls
    .filter((u) => u.url_type === 'figma')
    .map((u) => u.url)
    .join(', ')
}

function formatKickoffDate(dateString: string): string {
  if (!dateString) return ''
  const date = new Date(dateString)
  return date.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
}

export function exportProjectsToExcel(projects: ProjectExportData[]): void {
  const rows = projects.map((p) => ({
    'Nom du projet': p.nom,
    Description: p.description || '',
    'Date de kickoff': formatKickoffDate(p.date_kickoff),
    'Nom du chef de projet': p.project_managers?.length
      ? p.project_managers.map((pm) => pm.nom || pm.email).filter(Boolean).join(', ')
      : p.project_manager_nom || '',
    "Secteur d'activité": p.activity_sector_nom || '',
    'URL du schéma technique': getFigmaUrls(p.urls),
    'Stack technique': p.stack_technique || '',
  }))

  const worksheet = XLSX.utils.json_to_sheet(rows)
  worksheet['!cols'] = [
    { wch: 30 },
    { wch: 50 },
    { wch: 15 },
    { wch: 25 },
    { wch: 20 },
    { wch: 40 },
    { wch: 30 },
  ]

  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Projets')

  const date = new Date().toISOString().slice(0, 10)
  XLSX.writeFile(workbook, `projets_${date}.xlsx`)
}
